import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface Props {
  title: string;
}

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2.5),
  },
}));

const GridSectionTitle: FC<Props> = ({ title }) => {
  const classes = useStyles();

  return (
    <Typography noWrap className={classes.root} variant="h4" color="textSecondary">
      {title}
    </Typography>
  );
};

export default GridSectionTitle;
